module.exports = __webpack_public_path__ + "img/slide-5.e6e8073b.jpg";